import { Container, Col, Row } from "reactstrap";
import * as ViewQL from "queries/view";
import { Link } from "react-router-dom";
import { List } from "@repoflow/components/list-cursor";
import ViewSchema from "@common/schema/view/public";
import * as Section from "@repoflow/components/section";
import * as appWidgets from "@shared/widgets/register";

export const Sidebar = () => null;
export const Indice = () => null;

export const Content = ({ match: { params } }) => {
  const { base } = Section.useSectionContext();

  return (
    <Container>
      <div className="mt-4"></div>
      <Row>
        <Col>
          <Link className={"btn btn-primary"} to={`${base}/new`}>
            <i className="fa fa-plus" /> Add
          </Link>
        </Col>
      </Row>
      <div className="mt-4"></div>
      <List
        path={"viewer.account.views"}
        query={ViewQL.list}
        variables={params}
        schema={ViewSchema}
        target={{ $ref: "/Public/View" }}
        // Same reason as the tables listing: getField() resolves a widget for
        // every property of `/Public/View`, `params` and `tables` are arrays,
        // and an array resolves to the `list` widget, which is not built in.
        widgets={appWidgets}
        empty={"No views yet."}
        config={{
          // `tables` rather than `query`: which tables a view reads is the
          // thing worth seeing in a list, and it is derived rather than typed,
          // so it is also the honest summary of what the SQL does.
          "/Public/View": {
            fields: [
              "title",
              "viewId",
              // `tags` rather than leaving it to resolve(): `tables` is an array
              // of strings with no widget of its own, and an array falls through
              // to the `list` widget — which renders a nested editable table
              // inside a listing cell. The tags widget renders the same values
              // as badges, which is what a cell wants.
              { property: "tables", widget: "tags" },
              "updatedAt",
            ],
          },
        }}
        content={({ item: { viewId } }) => (
          <>
            <Link className={"btn btn-primary"} to={`${base}/${viewId}/`}>
              Open
            </Link>{" "}
          </>
        )}
      />
    </Container>
  );
};
